import index from "./headerBar.vue";
export default index;
